function initLoadMore() {

	var productsWrapperRows = document.querySelectorAll('.wine');

	if(productsWrapperRows){
		productsWrapperRows.forEach(productsWrapperRow => {
			loadMore( productsWrapperRow);
		});
	}

}

function loadMore( postWrapper ){
	var canBeLoaded = true, // this param allows to initiate the AJAX call only if necessary
		notMore = false,
		spinner = false;
		
		var loadMoreButton = postWrapper.querySelector(".load-more");
		var awardsWrapper = postWrapper.querySelector(".wine-awards-wrapper>.row");
		
		if(!loadMoreButton){
			return;
		}

		loadMoreButton.addEventListener('click', function (event) {
		
			// Don't follow the link
			event.preventDefault();

			const nElementsToLoad = 8;
			var awardsIds= postWrapper.dataset.hiddenAwardsIds.split(",");
			var nextAwardsIds = awardsIds.slice(nElementsToLoad);

			if(nextAwardsIds.length < 1){
				loadMoreButton.classList.add('hide'); // hide if no more awards
			}

			awardsIds = awardsIds.slice(0,nElementsToLoad);
			postWrapper.dataset.hiddenAwardsIds = nextAwardsIds;
	
				jQuery.ajax({
					url  : window.ajaxUrl,
					type : 'post',
					data : {
						action : 'atk_awards_load_more', 
						awards_ids : awardsIds.join(",")
					},
					beforeSend: function () {
						canBeLoaded = false;
						if(spinner){
							spinner.classList.remove('hide');
						}
					},
					success : function( result ) {

						if(result == 0){
							notMore = true;
						} else {
							awardsWrapper.insertAdjacentHTML('beforeend', result);
						}

						canBeLoaded = true; // the ajax is completed, now we can run it again
						if(spinner){
							spinner.classList.add('hide');
						}
					},
				});
			}, false);
}

initLoadMore();